import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HomePageService } from 'src/app/services/home-page.service';
import { OrderPDFModel, OrderPlaceModel, ProductResponseModel } from 'src/app/models/Home/home-list.model';
import { Router } from '@angular/router';
import { GetProductAssetModel, WarrantyDetailsModel } from 'src/app/models/product/productAssets.modal';
import { WarrantyServiceService } from 'src/app/services/warranty-service.service';
declare const Stripe: any;
@Component({
  selector: 'app-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.css']
})

export class PaymentStatusComponent implements OnInit {
  @Input('fileType') FileType: string = '1';
  @Input('fileChooseType') fileChooseType: string;

  stripe = Stripe(environment.stripeApiKey);
  orderPlaceModelVM: OrderPlaceModel = new OrderPlaceModel;
  ProductId: string;
  AddressId: string;
  WarrantyId: string;
  WarrantyPriceId: string;
  IsApplicationPriceSelected: string;
  Loader: boolean = false;
  LoaderImage: boolean = false;
  customerOrderPlanVm: OrderPDFModel = new OrderPDFModel();
  homeProductResponseModel: ProductResponseModel = new ProductResponseModel();
  showImageinMainFrame: GetProductAssetModel = new GetProductAssetModel();
  productAssets: GetProductAssetModel = new GetProductAssetModel();
  productImageResponseModel: Array<GetProductAssetModel> = new Array<GetProductAssetModel>();
  warrantyServiceItem: WarrantyDetailsModel = new WarrantyDetailsModel();
  DeliveryRateId: string;

  constructor(private homePageService: HomePageService, private router: Router, private _warrantyServiceService: WarrantyServiceService) { }

  ngOnInit() {
    this.productAssets.FileType = this.FileType;
    this.FileType == this.fileChooseType;
    this.ProductId = localStorage.getItem('productId');
    this.AddressId = localStorage.getItem('addressId');
    this.WarrantyId = localStorage.getItem('WarrentId');
    this.WarrantyPriceId = localStorage.getItem('WarrantyPriceId');
    this.IsApplicationPriceSelected = localStorage.getItem('IsApplicationPriceSelected');
    this.DeliveryRateId = localStorage.getItem('deliveryRateId');
    this.PaymentStatus();
    this.ProductWarrantyDetails();
  }

  PaymentStatus() {
    this.LoaderImage = true;
    const clientSecret = this.GetParameterByName("paymentId");
    this.orderPlaceModelVM = new OrderPlaceModel;
    this.stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      var payment = paymentIntent.id;
      this.orderPlaceModelVM.AddressId = this.AddressId;
      this.orderPlaceModelVM.ProductId = +this.ProductId;
      this.orderPlaceModelVM.PaymentId = payment;
      if(this.WarrantyId == 'undefined' && this.WarrantyPriceId == 'undefined')
      {
        this.WarrantyId = null;
        this.WarrantyPriceId = null;
      }
      this.orderPlaceModelVM.WarrantyId = this.WarrantyId; 
      this.orderPlaceModelVM.WarrantyPriceId = this.WarrantyPriceId;
      this.orderPlaceModelVM.IsApplicationPriceSelected = this.IsApplicationPriceSelected;
      this.orderPlaceModelVM.RateId = this.DeliveryRateId;
      if (this.orderPlaceModelVM.AddressId, this.orderPlaceModelVM.ProductId, this.orderPlaceModelVM.PaymentId, this.orderPlaceModelVM.WarrantyId, this.orderPlaceModelVM.WarrantyPriceId, this.orderPlaceModelVM.IsApplicationPriceSelected ) 
      {
        this.homePageService.CustomerPlaceOrder(this.orderPlaceModelVM)
          .subscribe((response) => {
            let responseBody = JSON.parse(response._body)
            if (responseBody.isSuccess) {
              this.customerOrderPlanVm = responseBody.responseData;
              this.ProductSingleImage();
              this.LoaderImage = false;
              localStorage.removeItem('productId');
              localStorage.removeItem('addressId');
              localStorage.removeItem('WarrantyPriceId');
              localStorage.removeItem('IsApplicationPriceSelected');
            } (err) => {
              this.LoaderImage = false;
              this.router.navigate(['/payment-cancel']);
            }
          })
      } else {
        this.router.navigate(['/payment-cancel']);
      }
    });
  }

  ProductSingleImage() {
    this.LoaderImage = true;
    this.orderPlaceModelVM.ProductId = +this.ProductId;
    this.homePageService.GetProductSingleImage(this.orderPlaceModelVM.ProductId)
      .subscribe((response) => {
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.homeProductResponseModel.ProductSort = responseBody.responseData;
          this.LoaderImage = false;
        }
      })
  }

  ProductWarrantyDetails() {
    this.Loader = true;
    this.warrantyServiceItem.warrantyId = +this.WarrantyId
    this._warrantyServiceService.ProductWarrantyServiceList(this.warrantyServiceItem)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        if (responseBody.isSuccess) {
          this.warrantyServiceItem = responseBody.responseData;
          localStorage.removeItem('WarrantyId');
        }
      });
  }

  ContinueShopping() {
    this.router.navigate(['/home-page']);
  }

  ProductTitle() {
    this.productAssets.ProductId = +this.ProductId;
    const url = this.router.serializeUrl(
    this.router.createUrlTree(['/product-page/' + this.productAssets.ProductId]));
    window.open('#' + url, '_blank');
  }

  GetParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}
